import {
  AfterViewInit,
  Directive,
  ElementRef,
  Injector,
  Input,
  OnChanges,
  SimpleChanges,
  afterNextRender,
  booleanAttribute,
  inject,
} from '@angular/core';

/**
 * Focuses the host element once it renders, and again whenever a bound value changes to true.
 * Use `certAutofocus` for elements revealed by an `@if`, or `[certAutofocus]="condition"` for elements that stay in the DOM.
 */
@Directive({
  selector: '[certAutofocus]',
  standalone: false,
})
export class AutofocusDirective implements OnChanges, AfterViewInit {
  @Input({ transform: booleanAttribute }) certAutofocus = true;

  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly injector = inject(Injector);

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['certAutofocus'];
    if (change && !change.firstChange && this.certAutofocus) {
      this.focus();
    }
  }

  ngAfterViewInit(): void {
    if (this.certAutofocus) {
      this.focus();
    }
  }

  private focus(): void {
    afterNextRender(() => this.el.nativeElement.focus(), { injector: this.injector });
  }
}
